import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: false,
        title: false,
    },
    interaction: {
        intersect: false,
    },
    scales: {
        x: {
            display: false // Hides labels and chart lines of the x-axis
        },
        y: {
            display: false // Hides labels and chart lines of the x-axis
        }
    }
};



export default function ProductStatisticsChart({ salesData, from, to }) {

    const labels = salesData.map(sale => sale.date_paid);

    const data = {
        labels,
        datasets: [
            {
                label: 'Dataset 2',
                data: salesData.map(sale => sale.quantity),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.1)',
                cubicInterpolationMode: 'monotone',
                // borderWidth: 2,
                tension: 0.6,
                fill: false,
            },
        ],
    };

    return (
        <div className='w-[140px]'>
            <Line options={options} data={data} />
        </div>
    );
}
